import api from './apiService';
import { API_PATHS } from '../constants/portalApiPath';

const predictiveService = {
  // Patient Dropout Risk — all patients
  getDropoutRisk: (data = {}) =>
    api.post(API_PATHS.PREDICTIVE_DROPOUT_RISK, data),

  // Patient Dropout Risk — single patient
  getPatientDropoutRisk: (patientId) =>
    api.post(API_PATHS.PREDICTIVE_DROPOUT_RISK_SINGLE, { patient_id: patientId }),

  // Revenue Forecast — next month
  getRevenueForecast: (data = {}) =>
    api.post(API_PATHS.PREDICTIVE_REVENUE_FORECAST, data),

  // Revenue Forecast — extended (next N months)
  getRevenueForecastExtended: (months = 3) =>
    api.post(API_PATHS.PREDICTIVE_REVENUE_FORECAST_EXTENDED, { months }),

  // Therapist Performance Rankings
  getTherapistPerformance: (data = {}) =>
    api.post(API_PATHS.PREDICTIVE_THERAPIST_PERFORMANCE, data),

  // Smart Business Advisor — all recommendations
  getBusinessAdvisor: (data = {}) =>
    api.post(API_PATHS.PREDICTIVE_BUSINESS_ADVISOR, data),

  // Data Health — duplicate bookings, zero-duration slots, invoice ledger drift
  getDataHealth: (data = {}) =>
    api.post(API_PATHS.PREDICTIVE_DATA_HEALTH, data),
};

export default predictiveService;
